import { F0Box, F0Heading, F0Text } from '@factorialco/f0-react'
import { NumberInput } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface OtherCostsSectionProps {
  subsidizedCost: number | null
  currency: string
  onChange: (value: number | null) => void
  error?: string
}

export const OtherCostsSection = ({
  subsidizedCost,
  currency,
  onChange,
  error
}: OtherCostsSectionProps) => {
  return (
    <F0Box display="flex" flexDirection="column" gap="xl" width="full" paddingTop="lg">
      <F0Box display="flex" flexDirection="column" gap="lg">
        <F0Heading content={i18n.t('trainings.classes.costs.other.title')} />
        <F0Text
          variant="description"
          content={i18n.t('trainings.classes.costs.other.description')}
        />
      </F0Box>

      <F0Box
        display="flex"
        flexDirection="column"
        padding="md"
        gap="lg"
        width="full"
        border="default"
        borderRadius="md"
        borderColor="secondary"
      >
        <F0Box display="flex" flexDirection="column" gap="xs">
          <F0Text variant="label" content={i18n.t('trainings.classes.costs.subsidized.title')} />
          <F0Text
            variant="description"
            content={i18n.t('trainings.classes.costs.subsidized.description')}
          />
        </F0Box>

        <NumberInput
          label={i18n.t('trainings.classes.costs.subsidized.title')}
          hideLabel
          locale={i18n.locale}
          units={currency}
          onChange={onChange}
          error={error}
          value={subsidizedCost}
          maxDecimals={2}
          size="md"
        />
      </F0Box>
    </F0Box>
  )
}
